import { useRequestEvent, useRoute } from "#imports";
const getCurrentUrl = (currentRoute = "") => {
  const event = useRequestEvent();
  const host = process.server ? event?.node.req.headers.host || "" : window.location.host;
  const [path] = useRoute().fullPath.split("?");
  const removedSlashes = currentRoute !== "" ? currentRoute : path.replace(/\/f\/?$/, "");
  return `https://${host}${removedSlashes}`;
};
export default getCurrentUrl;
